/*
 * Shared non-commerce behavior for all paid landers.
 *
 * Commerce, drawer state, attribution, and checkout belong exclusively to
 * xall-paid-offer.js. This controller keeps only the long-form interactions
 * shared by the otherwise identical page shells: media galleries, FAQ,
 * countdown, testimonial video, marquee, sticky CTA, and motion handling.
 */
(function () {
  'use strict';

  var root = document.getElementById('xall-lander');
  if (!root) return;

  var config = {};
  var dataNode = document.getElementById('xall-lander-data');
  try { config = dataNode ? JSON.parse(dataNode.textContent) : {}; } catch (error) {
    console.warn('[xall-lander-longform] Invalid page configuration', error);
  }
  var assets = config.assets || {};
  var state = { hero: 0, gallery: 0, testimonial: 0, faqOpen: {} };
  var heroKeys = ['hero1', 'hero2', 'hero3', 'hero4', 'hero5', 'hero6'];
  var heroAlt = [
    'X-ALL Multi-Purpose Cleaner loosening baked-on grease',
    'X-ALL Multi-Purpose Cleaner in action',
    'X-ALL Multi-Purpose Cleaner demonstration',
    'X-ALL Multi-Purpose Cleaner cleaning result',
    'X-ALL Multi-Purpose Cleaner before and after result',
    'X-ALL Multi-Purpose Cleaner on a tough household mess'
  ];
  var galleryKeys = ['buybox1', 'buybox2', 'buybox3', 'buybox4', 'buybox5', 'buybox6'];
  var galleryAlt = [
    'X-ALL Multi-Purpose Cleaner and refill tablets',
    'How to mix and use X-ALL Multi-Purpose Cleaner',
    'X-ALL loosening baked-on grease',
    'Shower corner before and after X-ALL',
    'Oven before and after X-ALL',
    'Bathtub before and after X-ALL'
  ];
  var videoKeys = { hero1: 'hero1Video', hero2: 'hero2Video', buybox3: 'buybox3Video' };
  var element = {
    countdown: root.querySelector('[data-xl="countdown"]'),
    heroImage: root.querySelector('[data-xl="hero-slide-img"]'),
    heroVideo: root.querySelector('[data-xl="hero-slide-video"]'),
    galleryImage: root.querySelector('[data-xl="buybox-slide-img"]'),
    galleryVideo: root.querySelector('[data-xl="buybox-slide-video"]'),
    dots: root.querySelectorAll('[data-xl="dot"]'),
    thumbs: root.querySelectorAll('[data-xl="thumb"]'),
    previous: root.querySelector('[data-xl="gallery-prev"]'),
    next: root.querySelector('[data-xl="gallery-next"]'),
    testimonials: root.querySelectorAll('[data-xl-testimonial]'),
    testimonialDots: root.querySelectorAll('[data-xl="testimonial-dot"]'),
    testimonialPrevious: root.querySelector('[data-xl="testimonial-prev"]'),
    testimonialNext: root.querySelector('[data-xl="testimonial-next"]'),
    faqItems: root.querySelectorAll('[data-xl-faq]'),
    wordScrim: root.querySelector('[data-xl="word-modal-scrim"]'),
    wordClose: root.querySelector('[data-xl="close-word-video"]'),
    wordVideo: root.querySelector('[data-xl="word-modal-video"]'),
    lazyVideos: root.querySelectorAll('[data-xl="lazy-video"]')
  };
  var wordReturnFocus = null;
  var marqueePaused = false;
  var heroMotionUnlocked = false;
  var pauseMarquee = function () { marqueePaused = true; };
  var resumeMarquee = function () { marqueePaused = false; };
  var countdownEnd = Date.now() + (6 * 60 * 60 + 35 * 60 + 7) * 1000;

  function text(node, value) { if (node) node.textContent = value; }
  function asset(key) { return assets[key] || ''; }
  function emit(name, detail) {
    var offer = root.querySelector('[data-xlo-offer]');
    var payload = Object.assign({ offer_id: offer ? offer.getAttribute('data-xlo-offer') : undefined }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    document.dispatchEvent(new CustomEvent('xall:' + name, { detail: payload }));
  }

  function promoteVideo(video) {
    if (!video) return;
    if (video.getAttribute('data-xl-promoted') !== 'true') {
      var source = video.querySelector('source[data-src]');
      if (source && source.getAttribute('data-src')) source.src = source.getAttribute('data-src');
      video.setAttribute('data-xl-promoted', 'true');
      try { video.load(); } catch (error) {}
    }
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function applyMedia(image, video, key, still, allowVideo) {
    var videoUrl = videoKeys[key] ? asset(videoKeys[key]) : '';
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (video && videoUrl && !reduced && allowVideo) {
      if (video.getAttribute('data-xl-src') !== videoUrl) {
        video.src = videoUrl;
        video.setAttribute('data-xl-src', videoUrl);
      }
      if (still) video.poster = still;
      video.hidden = false;
      if (image) image.hidden = true;
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
      return;
    }
    if (video) { video.pause(); video.hidden = true; }
    if (image) { image.hidden = false; if (still) image.src = still; }
  }

  function renderGallery() {
    var heroIndex = ((state.hero % heroKeys.length) + heroKeys.length) % heroKeys.length;
    var heroKey = heroKeys[heroIndex];
    applyMedia(element.heroImage, element.heroVideo, heroKey, asset(heroKey), heroMotionUnlocked);
    if (element.heroImage) element.heroImage.alt = heroAlt[heroIndex];
    if (element.heroVideo) element.heroVideo.setAttribute('aria-label', heroAlt[heroIndex]);
    element.dots.forEach(function (dot, index) { dot.classList.toggle('is-active', index === heroIndex); });

    var galleryIndex = ((state.gallery % galleryKeys.length) + galleryKeys.length) % galleryKeys.length;
    var galleryKey = galleryKeys[galleryIndex];
    applyMedia(element.galleryImage, element.galleryVideo, galleryKey, asset(galleryKey), true);
    if (element.galleryImage) element.galleryImage.alt = galleryAlt[galleryIndex];
    if (element.galleryVideo) element.galleryVideo.setAttribute('aria-label', galleryAlt[galleryIndex]);
    element.thumbs.forEach(function (thumb, index) { thumb.classList.toggle('is-active', index === galleryIndex); });
  }

  function renderTestimonials() {
    if (!element.testimonials.length) return;
    var index = ((state.testimonial % element.testimonials.length) + element.testimonials.length) % element.testimonials.length;
    element.testimonials.forEach(function (slide, slideIndex) { slide.classList.toggle('is-active', slideIndex === index); });
    element.testimonialDots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); });
  }

  function renderCountdown() {
    var remaining = Math.max(0, countdownEnd - Date.now());
    var hours = String(Math.floor(remaining / 3600000)).padStart(2, '0');
    remaining %= 3600000;
    var minutes = String(Math.floor(remaining / 60000)).padStart(2, '0');
    remaining %= 60000;
    text(element.countdown, hours + ':' + minutes + ':' + String(Math.floor(remaining / 1000)).padStart(2, '0'));
  }

  function openWordVideo(trigger) {
    if (!trigger || !element.wordScrim || !element.wordVideo) return;
    wordReturnFocus = trigger;
    pauseMarquee();
    var source = element.wordVideo.querySelector('source');
    if (source) source.setAttribute('data-src', trigger.getAttribute('data-xl-word-src') || '');
    var poster = trigger.getAttribute('data-xl-word-poster');
    if (poster) element.wordVideo.poster = poster;
    promoteVideo(element.wordVideo);
    element.wordScrim.classList.add('is-open');
    element.wordScrim.setAttribute('aria-hidden', 'false');
    document.body.classList.add('xl-scroll-lock');
    if (element.wordClose) element.wordClose.focus();
    emit('lander_word_video_open');
  }

  function closeWordVideo() {
    resumeMarquee();
    if (!element.wordScrim) return;
    element.wordScrim.classList.remove('is-open');
    element.wordScrim.setAttribute('aria-hidden', 'true');
    if (element.wordVideo) element.wordVideo.pause();
    document.body.classList.remove('xl-scroll-lock');
    if (wordReturnFocus && wordReturnFocus.focus) wordReturnFocus.focus();
    wordReturnFocus = null;
  }

  function toggleFaq(item) {
    var index = item.getAttribute('data-xl-faq');
    var open = !state.faqOpen[index];
    state.faqOpen[index] = open;
    var button = item.querySelector('[data-xl="faq-toggle"]');
    var panel = item.querySelector('[data-xl="faq-answer"]');
    var sign = item.querySelector('[data-xl="faq-sign"]');
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
    text(sign, open ? '–' : '+');
    if (open) emit('lander_faq_open', { index: Number(index) });
  }

  if (element.previous) element.previous.addEventListener('click', function () { heroMotionUnlocked = true; state.hero -= 1; renderGallery(); });
  if (element.next) element.next.addEventListener('click', function () { heroMotionUnlocked = true; state.hero += 1; renderGallery(); });
  element.dots.forEach(function (dot, index) { dot.addEventListener('click', function () { heroMotionUnlocked = true; state.hero = index; renderGallery(); }); });
  element.thumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { state.gallery = index; renderGallery(); }); });
  if (element.testimonialPrevious) element.testimonialPrevious.addEventListener('click', function () { state.testimonial -= 1; renderTestimonials(); });
  if (element.testimonialNext) element.testimonialNext.addEventListener('click', function () { state.testimonial += 1; renderTestimonials(); });
  element.testimonialDots.forEach(function (dot, index) { dot.addEventListener('click', function () { state.testimonial = index; renderTestimonials(); }); });
  element.faqItems.forEach(function (item) {
    var button = item.querySelector('[data-xl="faq-toggle"]');
    if (button) button.addEventListener('click', function () { toggleFaq(item); });
  });
  root.addEventListener('click', function (event) {
    var anchor = event.target.closest('a[href^="#"]');
    if (anchor) {
      var target = document.getElementById(anchor.getAttribute('href').slice(1));
      if (target) {
        event.preventDefault();
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
  });

  var wordStrip = root.querySelector('.xl-word-strip');
  if (wordStrip) wordStrip.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-xl="word-video-open"]');
    if (trigger) openWordVideo(trigger);
  });
  if (element.wordClose) element.wordClose.addEventListener('click', closeWordVideo);
  if (element.wordScrim) element.wordScrim.addEventListener('click', function (event) { if (event.target === element.wordScrim) closeWordVideo(); });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (element.wordScrim && element.wordScrim.classList.contains('is-open')) closeWordVideo();
  });

  if (wordStrip && wordStrip.children.length >= 2 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    wordStrip.style.scrollSnapType = 'none';
    wordStrip.setAttribute('data-xl-marquee', 'true');
    Array.prototype.slice.call(wordStrip.children).forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(clone.querySelectorAll('button, a'), function (node) { node.setAttribute('tabindex', '-1'); });
      wordStrip.appendChild(clone);
    });
    var visible = !('IntersectionObserver' in window);
    var position = wordStrip.scrollLeft;
    var last = 0;
    var idleTimer = null;
    var frameId = 0;
    function stop() {
      if (frameId) window.cancelAnimationFrame(frameId);
      frameId = 0;
      last = 0;
    }
    function schedule() {
      if (!frameId && visible && !marqueePaused && !document.hidden) frameId = window.requestAnimationFrame(step);
    }
    pauseMarquee = function () { marqueePaused = true; stop(); };
    resumeMarquee = function () { marqueePaused = false; position = wordStrip.scrollLeft; schedule(); };
    function resumeSoon(delay) { clearTimeout(idleTimer); idleTimer = setTimeout(resumeMarquee, delay || 2000); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (entries) {
      visible = entries[0] ? entries[0].isIntersecting : true;
      if (visible) schedule(); else stop();
    }, { rootMargin: '100px' }).observe(wordStrip);
    wordStrip.addEventListener('pointerenter', pauseMarquee);
    wordStrip.addEventListener('pointerleave', function () { resumeSoon(400); });
    wordStrip.addEventListener('touchstart', pauseMarquee, { passive: true });
    wordStrip.addEventListener('touchend', function () { resumeSoon(2500); }, { passive: true });
    wordStrip.addEventListener('focusin', pauseMarquee);
    wordStrip.addEventListener('focusout', function () { resumeSoon(400); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else schedule(); });
    function step(timestamp) {
      frameId = 0;
      if (marqueePaused || !visible || document.hidden) { stop(); return; }
      if (!last) last = timestamp;
      var delta = Math.min(64, timestamp - last);
      last = timestamp;
      if (Math.abs(wordStrip.scrollLeft - position) > 2) position = wordStrip.scrollLeft;
      position += 32 * delta / 1000;
      var half = wordStrip.scrollWidth / 2;
      if (half > 0 && position >= half) position -= half;
      wordStrip.scrollLeft = position;
      schedule();
    }
    schedule();
  }

  if (element.lazyVideos.length) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) promoteVideo(entry.target);
          else entry.target.pause();
        });
      }, { rootMargin: '100px 0px' });
      element.lazyVideos.forEach(function (video) { observer.observe(video); });
    } else element.lazyVideos.forEach(promoteVideo);
  }

  (function initSticky() {
    var bar = root.querySelector('.xl-sticky-bar');
    var hero = root.querySelector('.xl-hero');
    var buybox = root.querySelector('[data-xlo-buybox]');
    if (!bar || !hero || !buybox) return;
    var heroPassed = false;
    var buyboxVisible = false;
    function update() { bar.classList.toggle('is-shown', heroPassed && !buyboxVisible); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        heroPassed = entry ? !entry.isIntersecting && entry.boundingClientRect.bottom <= 0 : false;
        update();
      }).observe(hero);
      new IntersectionObserver(function (entries) { buyboxVisible = entries[0] ? entries[0].isIntersecting : false; update(); }).observe(buybox);
    } else {
      var fallbackUpdate = function () {
        var heroRect = hero.getBoundingClientRect();
        var buyboxRect = buybox.getBoundingClientRect();
        heroPassed = heroRect.bottom <= 0;
        buyboxVisible = buyboxRect.top < window.innerHeight && buyboxRect.bottom > 0;
        update();
      };
      window.addEventListener('scroll', fallbackUpdate, { passive: true });
      fallbackUpdate();
    }
  })();

  (function initScrollReveal() {
    if (!('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    document.documentElement.classList.add('xl-anim');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.remove('xl-reveal-pending'); entry.target.classList.add('xl-revealed'); observer.unobserve(entry.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    root.querySelectorAll('.xl-section, .xl-guarantee, .xl-final-cta, .xl-hero__proof-row').forEach(function (node) {
      var rect = node.getBoundingClientRect();
      if (rect.top >= window.innerHeight || rect.bottom <= 0) { node.classList.add('xl-reveal-pending'); observer.observe(node); }
    });
  })();

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.body.classList.remove('xl-scroll-lock', 'xl-checkout-leaving');
    renderGallery();
    renderTestimonials();
  });

  renderGallery();
  renderTestimonials();
  renderCountdown();
  window.setInterval(renderCountdown, 1000);
})();
